// React
import { FunctionComponent } from "react"

// Interfaces
import { I_SafetyEvent, I_SafetyEventWithApprovalHistory } from "../../interfaces"

// Services
import VIS from "../../VehicleIncidentsService"
import approvalService from "src/components/approvals/ApprovalService"

// Constants
import vehicleIncidentColorSet from "../../constants/VehicleIncidentColorSet"

// Styles
import "./VehicleIncidentsMiniInfo.css"


interface Props {
    id: number
}

const formatLabel = (key: string) =>
    key.replace(/([A-Z])/g, " $1").trim().replace(/^./, (c) => c.toUpperCase())

// Mini-info bar displaying all incident type bubbles and the employee name for a given event ID
const VehicleIncidentsMiniInfo: FunctionComponent<Props> = ({ id }) => {
    const { retrieveEventFromMap } = VIS
    const { retrieveEmployeeFromMap } = approvalService

    const event: I_SafetyEvent | I_SafetyEventWithApprovalHistory | null =
        retrieveEventFromMap(id || -1)

    if (!event) return null

    const employee = retrieveEmployeeFromMap(event.EmployeeID)
    const labels = (event.Label ?? "").split(",").map(l => l.trim()).filter(Boolean)

    return (
        <div className="VehicleIncidentsMiniInfo">
            <div className="VehicleIncidentsMiniInfoLabels">
                {labels.length > 0 ? labels.map((label) => (
                    <span key={label} className="VehicleIncidentsMiniInfoBubble">
                        <span
                            className="VehicleIncidentsMiniInfoDot"
                            style={{ backgroundColor: vehicleIncidentColorSet[label] || "#888" }}
                        />
                        {formatLabel(label)}
                    </span>
                )) : (
                    <span className="VehicleIncidentsMiniInfoBubble">
                        <span className="VehicleIncidentsMiniInfoDot" style={{ backgroundColor: "#888" }} />
                        {event.Name ?? ""}
                    </span>
                )}
            </div>

            <div className="VehicleIncidentsMiniInfoEmployee">
                <span>:</span>
                <span>{employee?.FirstName}</span>
                <span>{employee?.LastName}</span>
            </div>
        </div>
    )
}

export default VehicleIncidentsMiniInfo
